/* @flow */
import React from 'react';
import { graphql, createFragmentContainer } from 'react-relay';
import { Tabs, Tab } from 'material-ui/Tabs';

import Activity from './activity/Activity';
import TimeBasedChart from './TimeBasedChart';

const Metrics = ({ admin: { metrics } }) => {
  const timeBasedChartOptions = {
    scales: {
      xAxes: [{ stacked: true }],
      yAxes: [{ stacked: true }],
    },
  };

  return (
    <Tabs>
      <Tab label="Activity">
        <Activity metrics={metrics} />
      </Tab>
      <Tab label="Time Based">
        <TimeBasedChart
          timeBased={metrics.timeBased}
          options={timeBasedChartOptions}
        />
      </Tab>
      <Tab label="Geo Map" />
    </Tabs>
  );
};

export default createFragmentContainer(Metrics, {
  admin: graphql`
    fragment Metrics_admin on Admin {
      metrics {
        timeBased {
          ...TimeBasedChart_timeBased
        }
        ...Activity_metrics
      }
    }
  `,
});



// WEBPACK FOOTER //
// ./src/components/home/Metrics.js